import { apiBasic, apiGet } from "./requests";

/**
 * Orders
 */

export const getOrders = (params = null) => {
  const path = "get-orders";
  return apiGet(path, params);
};

export const getOrderDetails = (id) => {
  const path = "get-order-details/" + id;
  return apiGet(path);
};

export const addOrderNote = (payload, id) => {
  const path = `order/${id}/add-note`;
  return apiBasic(payload, path, "patch");
};

export const addOrderDiscount = (payload, id) => {
  const path = `add-orders-to-discount/${id}`;
  return apiBasic(payload, path, "post");
};

export const removeOrderDiscount = (orderId, discountId) => {
  const path = `order/${orderId}/discount/${discountId}`;
  return apiBasic(null, path, "delete");
};

export const makeOrder = (payload) => {
  const path = "make-order";
  return apiBasic(payload, path, "post");
};

export const payOrder = (payload) => {
  const path = "pay-order";
  return apiBasic(payload, path, "post");
};

/**
 * Cart / Address helpers
 * (Ojo: addAddressToCart solapa funcionalidad con api/cart.js -> addCartShippingAddress,
 * pero lo mantenemos para compatibilidad.)
 */
export const addAddressToCart = (payload, id) => {
  const path = `shopping-cart/${id}/add-address`;
  return apiBasic(payload, path, "patch");
};

/**
 * Discounts
 */
export const getDiscounts = () => {
  const path = "discounts";
  return apiGet(path);
};

/**
 * Update / Billing
 */
export const updateOrder = (payload, id) => {
  const path = `order/${id}/update-pending-order`;
  return apiBasic(payload, path, "patch");
};

export const createInvoice = (payload) => {
  const path = "create-invoice";
  return apiBasic(payload, path, "post");
};

/**
 * Printing
 */
export const printTicket = (payload) => {
  const path = "print-new-order";
  return apiBasic(payload, path, "post");
};

export const printInvoice = (payload) => {
  const path = "print-order";
  return apiBasic(payload, path, "post");
};

/*********** ORDER EDITION *************/

export const updatePendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/update-pending-order`;
  return apiBasic(payload, path, "patch");
};

export const addProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/add-product-to-pending-order`;
  return apiBasic(payload, path, "post");
};

export const updateQuantityProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/update-pending-order-product-quantity`;
  return apiBasic(payload, path, "patch");
};

export const removeProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/remove-product-from-pending-order`;
  return apiBasic(payload, path, "post");
};

export const getClients = (params = null) => {
  let path = "customers";
  return apiGet(path, params);
};

export const getAttributeGroups = () => {
  let path = "item-groups/";
  return apiGet(path);
};

export const getOptionGroups = () => {
  let path = "option-groups/";
  return apiGet(path);
};

export const updateOrderStatus = (payload, orderId) => {
  const path = `update-order-status/${orderId}`;
  return apiBasic(payload, path, "patch");
};

export const deleteDiscount = (discountId) => {
  const path = `discount/${discountId}`;
  return apiBasic(null, path, "delete");
};

export const releaseReturnedOrder = (id) => apiBasic({status: "prepared"}, `order/${id}/delivery-status`, "patch");

export const handoverPickupOrder = (id, payload) => apiBasic(payload, `order/${id}/pickup-handover`, 'patch');
